<template>
  <svg
    viewBox="0 0 278 150"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="m236.46 2.68 6 10.39c.16.26.27.54.36.81 1 .05 1.99.22 2.94.51l23.73 7.2A12 12 0 0 1 278 33.09V114a12 12 0 0 1-8.24 11.39l-23.82 7.87a12 12 0 0 1-2.55.54l-5.93 10.26a4 4 0 0 1-6.92-4l3.57-6.2H12a12 12 0 0 1-12-11.7v-96.3a12 12 0 0 1 12-12h221.69l-4.15-7.2a4 4 0 0 1 6.92-4zm5.82 19.2H12a4 4 0 0 0-4 4v96a4 4 0 0 0 4 4h230.18a4 4 0 0 0 1.25-.21l23.82-7.87A4 4 0 0 0 270 114V33.08a4 4 0 0 0-2.84-3.83l-23.72-7.2a4 4 0 0 0-1.16-.18z"
        fill="currentColor"
        fill-rule="nonzero"
      />
      <g transform="translate(74 42)">
        <path
          fill="currentColor"
          d="M29 0h4v62h-4zm14 0h4v62h-4z"
        />
        <path
          fill="currentColor"
          d="M33 29v4H1v-4z"
        />
        <rect
          stroke="currentColor"
          stroke-width="4"
          stroke-linejoin="round"
          width="123"
          height="62"
          rx="4"
        />
      </g>
      <path
        d="m202.68 30.7-1.47 3.72A5.98 5.98 0 0 0 199 34v-4c1.27 0 2.52.24 3.68.7zm5.37 5.05-3.62 1.7a6.02 6.02 0 0 0-1.32-1.82l2.74-2.92a10.02 10.02 0 0 1 2.2 3.03zm.95 6.76h-4V40l-.01-.36 4-.25.01.61v2.52zm0 6h-4v-3h4v3zm0 6h-4v-3h4v3zm0 6h-4v-3h4v3zm0 6h-4v-3h4v3zm0 6h-4v-3h4v3zm0 6h-4v-3h4v3zm0 6h-4v-3h4v3zm0 6h-4v-3h4v3zm0 6h-4v-3h4v3zm0 6h-4v-3h4v3zm-.49 6.6-3.8-1.25A6 6 0 0 0 205 106v-.49h4v.49a10 10 0 0 1-.49 3.1zm-4.7 5.66-1.93-3.5a6.04 6.04 0 0 0 1.74-1.44l3.08 2.56a10.04 10.04 0 0 1-2.9 2.38zm-6.84 1.23v-4h2.04c.25 0 .5-.02.74-.05l.49 3.97c-.4.05-.81.08-1.22.08h-2.04zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6 0v-4h3v4h-3zm-6.25-.08.51-3.97c.25.03.51.05.77.05h1.97v4H72c-.43 0-.85-.03-1.28-.08zm-6.46-3.6 3.1-2.52a6.04 6.04 0 0 0 1.72 1.44l-1.95 3.5a10.04 10.04 0 0 1-2.87-2.41zM62 105.47h4v.54a6 6 0 0 0 .26 1.75l-3.83 1.17A10 10 0 0 1 62 106v-.54zm0-6h4v3h-4v-3zm0-6h4v3h-4v-3zm0-6h4v3h-4v-3zm0-6h4v3h-4v-3zm0-6h4v3h-4v-3zm0-6h4v3h-4v-3zm0-6h4v3h-4v-3zm0-6h4v3h-4v-3zm0-6h4v3h-4v-3zm0-6h4v3h-4v-3zm.02-6.13 4 .26A6.12 6.12 0 0 0 66 40v2.46h-4V40c0-.22 0-.45.02-.67zm3.18-6.66 2.72 2.93a6.02 6.02 0 0 0-1.34 1.81l-3.6-1.72a10.02 10.02 0 0 1 2.22-3.02zM72.05 30v4H72c-.73 0-1.45.13-2.12.38l-1.4-3.74a9.97 9.97 0 0 1 3.11-.63l.46-.01zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3zm6 0v4h-3v-4h3z"
        fill="currentColor"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>
